import { render, staticRenderFns } from "./StaffGroupProfile.vue?vue&type=template&id=94457dd8&scoped=true&"
import script from "./StaffGroupProfile.vue?vue&type=script&lang=js&"
export * from "./StaffGroupProfile.vue?vue&type=script&lang=js&"
import style0 from "./StaffGroupProfile.vue?vue&type=style&index=0&id=94457dd8&prod&scoped=true&lang=css&"
import style1 from "./StaffGroupProfile.vue?vue&type=style&index=1&id=94457dd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94457dd8",
  null
  
)

export default component.exports